import { configureStore } from '@reduxjs/toolkit';
import conversationSlice from './conversationSlice';
import connectionSlice from './connectionSlice';
import authSlice from './authSlice';
import competitorSlice from './slices/competitorSlice';
import landmineSlice from './slices/landmineSlice';
import salesPlaybookSlice from './slices/salesPlaybookSlice';
import hotButtonSlice from './slices/hotButtonSlice';

export const store = configureStore({
  reducer: {
    conversation: conversationSlice,
    connection: connectionSlice,
    auth: authSlice,
    competitor: competitorSlice,
    landmine: landmineSlice,
    salesPlaybook: salesPlaybookSlice,
    hotButton: hotButtonSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/loginUser/fulfilled', 'auth/setUser'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.user', 'payload.tokenInfo'],
        // Ignore these paths in the state
        ignoredPaths: ['auth.user', 'auth.tokenInfo'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
